/** Migra claves localStorage legacy (puestito_*) a puestify_*. */
export function migrateStorageKey(oldKey, newKey) {
    if (!oldKey || !newKey || oldKey === newKey) return;
    try {
        const existing = localStorage.getItem(newKey);
        const legacy = localStorage.getItem(oldKey);
        if (legacy != null && existing == null) {
            localStorage.setItem(newKey, legacy);
        }
        if (legacy != null) {
            localStorage.removeItem(oldKey);
        }
    } catch (_) {
        /* ignore */
    }
}

export function posDraftStorageKey(usuario) {
    const key = `puestify_pos_draft_v1_${usuario || ''}`;
    migrateStorageKey(`puestito_pos_draft_v1_${usuario || ''}`, key);
    return key;
}

export function cartStorageKey(slugNegocio) {
    const key = `puestify_cart_v1_${slugNegocio}`;
    migrateStorageKey(`puestito_cart_v1_${slugNegocio}`, key);
    return key;
}

export function cartTotalStorageKey(slugNegocio) {
    const key = `puestify_cart_total_v1_${slugNegocio}`;
    migrateStorageKey(`puestito_cart_total_v1_${slugNegocio}`, key);
    return key;
}

export function pedidoDraftStorageKey(usuario) {
    const key = `puestify_pedido_v1_${usuario}`;
    migrateStorageKey(`puestito_pedido_v1_${usuario}`, key);
    return key;
}

export function gondolaSnapshotKey(usuario) {
    return `puestify_gondola_snapshot_v1_${usuario || ''}`;
}

export function gondolaSettingsKey(usuario) {
    return `puestify_gondola_settings_v1_${usuario || ''}`;
}
